import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAVGmQ8MQyXszQwrZIAjkpNpV2k_vjD9ds",
  authDomain: "glpbattles.firebaseapp.com",
  projectId: "glpbattles",
  storageBucket: "glpbattles.firebasestorage.app",
  messagingSenderId: "91260930880",
  appId: "1:91260930880:web:2603ccdc6f145576c308a5"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

export { auth, db, googleProvider };
